import { render, staticRenderFns } from "./ApplicationMain.vue?vue&type=template&id=731ad74a&scoped=true&"
import script from "./ApplicationMain.vue?vue&type=script&lang=js&"
export * from "./ApplicationMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731ad74a",
  null
  
)

export default component.exports